// =====================================================================================
// The back-office "new look" colours (the calm settings style: white surfaces, warm-grey
// hairlines, dark primary buttons, blue #2A78D6 accent). Shared by the global theme layer
// (theme/newLook.ts) and the page primitives (Settings/CompanySettings/settingsUi.tsx) so
// every screen uses exactly the same values. Cashier POS screens keep the legacy theme.
// =====================================================================================

export interface NewLookTokens {
  pageBg: string;
  navBg: string;
  border: string;
  rowDivider: string;
  selected: string;
  hover: string;
  text: string;
  navText: string;
  muted: string;
  searchBg: string;
  searchBorder: string;
  accent: string;
  toggleOff: string;
  buttonBg: string;
  buttonText: string;
  subtleBg: string;
}

export const NEW_LOOK_LIGHT: NewLookTokens = {
  pageBg: '#FFFFFF',
  navBg: '#FCFCFB',
  border: '#E3E3E2',
  rowDivider: '#F0F0EF',
  selected: '#E3E3E2',
  hover: '#EFEFEE',
  text: '#141413',
  navText: '#52514E',
  muted: '#87867F',
  searchBg: '#FEFEFD',
  searchBorder: '#E5E5E4',
  accent: '#2A78D6',
  toggleOff: '#CFCFCF',
  buttonBg: '#141413',
  buttonText: '#FFFFFF',
  subtleBg: '#F7F7F6',
};

export const NEW_LOOK_DARK: NewLookTokens = {
  pageBg: '#1F1F1E',
  navBg: '#262624',
  border: 'rgba(255,255,255,0.10)',
  rowDivider: 'rgba(255,255,255,0.07)',
  selected: 'rgba(255,255,255,0.10)',
  hover: 'rgba(255,255,255,0.06)',
  text: '#F2F1EE',
  navText: '#C8C6C0',
  muted: '#9C9A93',
  searchBg: '#1F1F1E',
  searchBorder: 'rgba(255,255,255,0.14)',
  accent: '#3B86E0',
  toggleOff: '#5A5955',
  buttonBg: '#F2F1EE',
  buttonText: '#141413',
  subtleBg: 'rgba(255,255,255,0.04)',
};
